var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82496 1.53225H5.39055C3.73223 1.5264 2.37285 2.84838 2.33377 4.50646L2.33363 4.51825V11.655C2.30007 13.337 3.63432 14.73 5.31717 14.7675L5.32829 14.7676C5.33277 14.7676 5.33559 14.7676 5.34005 14.7677C5.3435 14.7677 5.34793 14.7678 5.35486 14.7678C5.36531 14.7679 5.37979 14.768 5.39631 14.7676H9.7041C9.98024 14.7676 10.2041 14.5437 10.2041 14.2676V14.2676C10.2041 13.9914 9.98024 13.7676 9.7041 13.7676H5.38963C5.38425 13.7676 5.37888 13.7677 5.37351 13.7678L5.37117 13.7679L5.36306 13.7678L5.34879 13.7677L5.33602 13.7676C4.20503 13.7406 3.30887 12.8028 3.33351 11.6711L3.33363 11.6602V4.52445C3.36278 3.41348 4.275 2.52797 5.3877 2.53225H9.61185L12.7016 5.75074L12.7016 9.11075C12.7016 9.3869 12.9255 9.61076 13.2016 9.61076V9.61076C13.4778 9.61076 13.7016 9.3869 13.7016 9.11076V5.54958C13.7016 5.4205 13.6517 5.29643 13.5623 5.20331L10.1857 1.68598C10.0914 1.58776 9.96111 1.53225 9.82496 1.53225Z",
    fill: "#8395A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6499 1.52441C9.92604 1.52441 10.1499 1.74827 10.1499 2.02441V3.96375C10.1499 4.63455 10.6918 5.17819 11.3627 5.18041H13.1986C13.4747 5.18041 13.6986 5.40427 13.6986 5.68041C13.6986 5.95656 13.4747 6.18041 13.1986 6.18041H11.3619L11.3605 6.18041C10.1383 6.17697 9.1499 5.18607 9.1499 3.96375V2.02441C9.1499 1.74827 9.37376 1.52441 9.6499 1.52441Z",
    fill: "#8395A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42529 10.4302C5.42529 10.154 5.64915 9.93018 5.92529 9.93018H9.52529C9.80144 9.93018 10.0253 10.154 10.0253 10.4302C10.0253 10.7063 9.80144 10.9302 9.52529 10.9302H5.92529C5.64915 10.9302 5.42529 10.7063 5.42529 10.4302Z",
    fill: "#8395A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4248 7.92847C5.4248 7.65232 5.64866 7.42847 5.9248 7.42847H8.16214C8.43828 7.42847 8.66214 7.65232 8.66214 7.92847C8.66214 8.20461 8.43828 8.42847 8.16214 8.42847H5.9248C5.64866 8.42847 5.4248 8.20461 5.4248 7.92847Z",
    fill: "#8395A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0664 10.4346C13.3425 10.4346 13.5664 10.6584 13.5664 10.9346V14.2679C13.5664 14.544 13.3425 14.7679 13.0664 14.7679C12.7903 14.7679 12.5664 14.544 12.5664 14.2679V10.9346C12.5664 10.6584 12.7903 10.4346 13.0664 10.4346Z",
    fill: "#8395A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8999 12.6013C10.8999 12.3252 11.1238 12.1013 11.3999 12.1013H14.7332C15.0094 12.1013 15.2332 12.3252 15.2332 12.6013C15.2332 12.8775 15.0094 13.1013 14.7332 13.1013H11.3999C11.1238 13.1013 10.8999 12.8775 10.8999 12.6013Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDeal);
export default __webpack_public_path__ + "static/media/add_deal.9a1e15ad24c69afb8fa173356225fb49.svg";
export { ForwardRef as ReactComponent };